import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { COMMUNITY_FEATURES, PLAY_PAGE_FEATURES } from "@/config/playPageConfig";
import "./CommunityCards.scss";

interface CommunityCardsProps {
    title?: string;
    isLoading?: boolean;
}

/**
 * CommunityCards Component
 * Displays promotional and informational cards (Discord, LootBoxes, Spin & Earn, etc.)
 * Separate from Brand Challenges for better organization
 */
const CommunityCards: React.FC<CommunityCardsProps> = ({
    title = "🎮  Around DevourPlay",
    isLoading = false,
}) => {
    const navigate = useNavigate();

    const handleFeatureClick = useCallback((feature: typeof COMMUNITY_FEATURES[0]) => {
        if (feature.external) {
            window.open(feature.path, "_blank");
        } else {
            navigate(feature.path);
        }
    }, [navigate]);

    if (isLoading) {
        return (
            <div className="community-cards community-cards--loading">
                <div className="community-cards__skeleton-title" />
                <div className="community-cards__skeleton-card" />
                <div className="community-cards__skeleton-card" />
                <div className="community-cards__skeleton-card" />
            </div>
        );
    }

    // Filter enabled features
    const enabledFeatures = COMMUNITY_FEATURES.filter(feature =>
        PLAY_PAGE_FEATURES.communityFeatures[feature.id as keyof typeof PLAY_PAGE_FEATURES.communityFeatures]);

    if (enabledFeatures.length === 0) {
        return null;
    }

    return (
        <div className="community-cards">
            <h3 className="community-cards__title">{title}</h3>

            {enabledFeatures.map((feature) =>
                <button
                    key={feature.id}
                    className="feature-card"
                    onClick={() => handleFeatureClick(feature)}
                >
                    <img
                        src={feature.icon}
                        alt={feature.title}
                        className="feature-icon"
                    />
                    <div className="feature-info">
                        <h4 className="feature-title">{feature.title}</h4>
                        <p className="feature-subtitle">{feature.subtitle}</p>
                    </div>
                </button>)}
        </div>
    );
};

export default React.memo(CommunityCards);